import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, AlertTriangle, CheckCircle, Download } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function ComplianceTrackingPage() {
  const navigate = useNavigate();
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const handleViewDetails = (id: string) => {
    navigate(`/authority/compliance/${id}`);
  };
  const handleExportReport = () => {
    setIsExportModalOpen(true);
  };
  return <DashboardLayout title="Compliance Tracking" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2523">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-2524">
        <div data-id="element-2525">
          <h1 className="text-2xl font-bold mb-1" data-id="element-2526">Developer Compliance</h1>
          <p className="text-gray-500 font-mono text-sm" data-id="element-2527">
            Monitor RERA registrations and zone violations.
          </p>
        </div>
        <button onClick={handleExportReport} className="flex items-center gap-2 px-4 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50" data-id="element-2528">
          <Download className="w-4 h-4" data-id="element-2529" /> Export Report
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2530">
        <div className="bg-white border border-gray-300 p-6 border-l-4 border-l-green-500" data-id="element-2531">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2532">
            Fully Compliant
          </h3>
          <p className="text-3xl font-bold" data-id="element-2533">842</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-2534">Developers</p>
        </div>
        <div className="bg-white border border-gray-300 p-6 border-l-4 border-l-yellow-500" data-id="element-2535">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2536">
            Pending Review
          </h3>
          <p className="text-3xl font-bold" data-id="element-2537">56</p>
          <p className="text-xs text-yellow-600 mt-1" data-id="element-2538">Applications</p>
        </div>
        <div className="bg-white border border-gray-300 p-6 border-l-4 border-l-red-500" data-id="element-2539">
          <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-2540">
            Violations
          </h3>
          <p className="text-3xl font-bold" data-id="element-2541">12</p>
          <p className="text-xs text-red-600 mt-1" data-id="element-2542">Active Cases</p>
        </div>
      </div>

      <div className="bg-white border border-gray-300 overflow-hidden" data-id="element-2543">
        <div className="p-4 border-b border-gray-200 bg-gray-50 font-bold text-sm" data-id="element-2544">
          Recent Compliance Updates
        </div>
        <div className="overflow-x-auto" data-id="element-2545">
          <table className="w-full text-left text-sm min-w-[800px]" data-id="element-2546">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-2547">
              <tr data-id="element-2548">
                <th className="p-4 font-bold" data-id="element-2549">Developer</th>
                <th className="p-4 font-bold" data-id="element-2550">Project</th>
                <th className="p-4 font-bold" data-id="element-2551">Type</th>
                <th className="p-4 font-bold" data-id="element-2552">Status</th>
                <th className="p-4 font-bold" data-id="element-2553">Last Updated</th>
                <th className="p-4 font-bold text-right" data-id="element-2554">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2555">
              {[{
              id: '1',
              dev: 'Sunrise Developers',
              proj: 'Green Valley',
              type: 'RERA Registration',
              status: 'Approved',
              date: 'Today, 10:30 AM'
            }, {
              id: '2',
              dev: 'Urban Spaces Ltd',
              proj: 'City Center',
              type: 'Zone Check',
              status: 'Flagged',
              date: 'Yesterday',
              alert: true
            }, {
              id: '3',
              dev: 'Raj Realty',
              proj: 'Lakeside Plots',
              type: 'NA Order',
              status: 'Pending',
              date: 'Oct 20, 2024'
            }, {
              id: '4',
              dev: 'Golden Earth',
              proj: 'Sector 9',
              type: 'Tax Clearance',
              status: 'Approved',
              date: 'Oct 18, 2024'
            }].map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-2556">
                  <td className="p-4 font-bold" data-id="element-2557">{item.dev}</td>
                  <td className="p-4 text-gray-600" data-id="element-2558">{item.proj}</td>
                  <td className="p-4 font-mono text-xs" data-id="element-2559">{item.type}</td>
                  <td className="p-4" data-id="element-2560">
                    <div className="flex items-center gap-2" data-id="element-2561">
                      {item.status === 'Approved' && <CheckCircle className="w-4 h-4 text-green-500" data-id="element-2562" />}
                      {item.status === 'Flagged' && <AlertTriangle className="w-4 h-4 text-red-500" data-id="element-2563" />}
                      {item.status === 'Pending' && <div className="w-4 h-4 rounded-full border-2 border-gray-300 border-t-gray-600 animate-spin" data-id="element-2564" />}
                      <span className={`text-xs font-bold ${item.status === 'Approved' ? 'text-green-700' : item.status === 'Flagged' ? 'text-red-700' : 'text-gray-600'}`} data-id="element-2565">
                        {item.status.toUpperCase()}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 text-xs text-gray-500" data-id="element-2566">{item.date}</td>
                  <td className="p-4 text-right" data-id="element-2567">
                    <button onClick={() => handleViewDetails(item.id)} className="text-blue-600 hover:underline font-bold text-xs" data-id="element-2568">
                      View Details
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <MessageModal isOpen={isExportModalOpen} onClose={() => setIsExportModalOpen(false)} title="Export Compliance Report" message="Generating comprehensive compliance report with all developer records, RERA registrations, and violation details. Download will begin shortly." type="success" data-id="element-2569" />
    </DashboardLayout>;
}